<section class="feedback-area ptb-100">
    <div class="container">
        <div class="feedback-slides owl-carousel owl-theme">
            <div class="single-feedback-item">
                <p>“Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.”</p>

                <div class="info">
                    <h3>James Anderson</h3>
                    <span>Switzerland</span>
                    <img src="assets/img/feedback1.jpg" class="shadow rounded-circle" alt="image">
                </div>
            </div>

            <div class="single-feedback-item">
                <p>“Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.”</p>

                <div class="info">
                    <h3>Lina D'Souza</h3>
                    <span>Iceland</span>
                    <img src="assets/img/feedback2.jpg" class="shadow rounded-circle" alt="image">
                </div>
            </div>

            <div class="single-feedback-item">
                <p>“Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.”</p>

                <div class="info">
                    <h3>David Warner</h3>
                    <span>Antarctica</span>
                    <img src="assets/img/feedback3.jpg" class="shadow rounded-circle" alt="image">
                </div>
            </div>
        </div>
    </div>
</section>